import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDoAndDont32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconDoAndDont32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.5 5a6.5 6.5 0 1 0 .893 12.94 8.5 8.5 0 0 1 1.385-2.643l-2.33-2.33-1.801 1.8a1 1 0 0 1-1.415-1.413l1.801-1.802-1.906-1.906a1 1 0 0 1 1.415-1.414l1.906 1.906 2.01-2.01a1 1 0 1 1 1.415 1.414l-2.011 2.01 2.318 2.318a8.5 8.5 0 0 1 2.76-1.477q.06-.438.06-.893A6.5 6.5 0 0 0 11.5 5m8.485 7.015Q20 11.76 20 11.5a8.5 8.5 0 1 0-7.985 8.485Q12 20.24 12 20.5a8.5 8.5 0 1 0 7.985-8.485M20.5 14a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13m4.46 4.04a1 1 0 0 1 0 1.414l-4.506 4.506-.707.707-.707-.707-2.539-2.538a1 1 0 1 1 1.415-1.414l1.83 1.83 3.8-3.798a1 1 0 0 1 1.415 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDoAndDont32);
